import React from 'react';
import { useRouterContext, useRouterType, useLink } from '@refinedev/core';
import {
  Center,
  Image,
  Text,
  useMantineTheme,
  useComputedColorScheme,
} from '@mantine/core';
import type { RefineLayoutThemedTitleProps } from '@refinedev/mantine';

export const Title: React.FC<
  RefineLayoutThemedTitleProps & { size?: number }
> = ({ collapsed, icon, size = 50 }) => {
  const text = localStorage.getItem('organization') ?? '';
  const theme = useMantineTheme();
  const computedColorScheme = useComputedColorScheme('dark');
  const routerType = useRouterType();
  const Link = useLink();
  const { Link: LegacyLink } = useRouterContext();

  const ActiveLink = routerType === 'legacy' ? LegacyLink : Link;

  if (!icon) {
    icon = (
      <Image
        src={`/q-crop-${computedColorScheme}.png`}
        maw={size}
        miw={size}
        alt="QDoc Logo"
        fallbackSrc="./public/placeholder-image.jpg"
        style={{ marginLeft: '20%' }}
      />
    );
  }

  return (
    <ActiveLink to="/" style={{ all: 'unset' }}>
      <Center
        style={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: collapsed ? 'center' : 'flex-start',
          gap: '8px',
        }}
      >
        {!collapsed && (
          <>
            <Text
              lh={0}
              fz="inherit"
              c={theme.activeClassName === 'dark' ? 'brand.5' : 'brand.6'}
            >
              {icon}
            </Text>
            <Text
              fz="lg"
              c={theme.activeClassName === 'dark' ? 'white' : 'black'}
            >
              {text}
            </Text>
          </>
        )}
      </Center>
    </ActiveLink>
  );
};
